import { PageType, PageTypes } from 'strapi/page/types';
import { ReactComponentBuildResponse } from 'strapi/types';

import { fetchDataFromJson } from '../aiTextToolForm/utils';
import { collectImageComponentParams } from '../shared/collector';
import { ReactComponentType } from '../types';

import AiTextTool from './AiTextTool';

export const collectAiTextToolParams = (
  _: PageType,
  page: PageTypes
): ReactComponentBuildResponse<typeof AiTextTool> | undefined => {
  if (!('aiTextTool' in page) || !page.aiTextTool) {
    return undefined;
  }

  return {
    component: ReactComponentType.AiTextTool,
    props: {
      toolConfigs: fetchDataFromJson(page.aiTextTool.toolConfigs),
      background: collectImageComponentParams(page.aiTextTool.background),
      title: page.aiTextTool.title,
      titleResults: page.aiTextTool.titleResult,
      description: page.aiTextTool.description,
      buttonLabel: page.aiTextTool.buttonLabel,
      promptId: page.aiTextTool.promptId,
      numberOfOutputs: page.aiTextTool.numberOfOutputs,
      textType: page.aiTextTool.textType,
    },
  };
};
